//*Variables para fechas de corte de tiendas
var dateStart = new Date();
var dateEnd = new Date();

function getNumberOfDays(num = 1) {
  return 24 * 60 * 60 * 1000 * num;
}

function getStartDate(min) {
  const startDate = new Date();
  startDate.setTime(startDate.getTime() + getNumberOfDays(min));
  return startDate.toISOString();
}

function currentWeek() {
  var res = [];
  var a = new Date();
  var r = a.getDay();
  /*GET DAY returns the number day of system date, when 0 is Sunday and 6 is saturday */

  switch (r) {
    case 0: //ES DOMINGO
      dateStart = getStartDate(-1);
      dateEnd = getStartDate(5);
      break;
    case 1: //ES LUNES
      dateStart = getStartDate(-2);
      dateEnd = getStartDate(+4);
      break;
    case 2: //ES MARTES
      dateStart = getStartDate(-3);
      dateEnd = getStartDate(+3);
      break;
    case 3: //ES MIÉRCOLES
      dateStart = getStartDate(-4);
      dateEnd = getStartDate(+2);
      break;
    case 4: //ES JUEVES
      dateStart = getStartDate(-5);
      dateEnd = getStartDate(+1);
      break;
    case 5: //ES VIERNES
      //FIN DE LA SEMANA SOLO SE OBTIENE LA FECHA DEL SABADO ANTERIOR
      dateStart = getStartDate(-6);
      dateEnd = new Date();
      break;
    case 6: //ES SÁBADO
      //INICIO DE LA SEMANA SE OBTIENE EL VIERNES PRÓXIMO
      dateStart = new Date();
      dateEnd = getStartDate(+6);
      break;
    default:
      break;
  }
  res.push(dateStart, dateEnd);
  return res;
  //return res;
}

export default currentWeek;
